var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 0H64C28.6538 0 0 28.6538 0 64V192C0 227.346 28.6538 256 64 256H192C227.346 256 256 227.346 256 192V64C256 28.6538 227.346 0 192 0Z",
    fill: "#1D19E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3733 192.356L100.338 105.742L70.7555 63.6445L31.5022 150.258L60.3733 192.356Z",
    fill: "#F3F3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.453 192.356L162.418 105.742L132.836 63.6445L93.5823 150.258L122.453 192.356Z",
    fill: "#F3F3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.533 192.356L224.498 105.742L194.915 63.6445L155.662 150.258L184.533 192.356Z",
    fill: "#F3F3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.e4b316bca0b017300dcccd8b92b92b9f.svg";
export { ForwardRef as ReactComponent };